'use strict';

export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::course-copy.read',
    subject: null
  }]
};